/**
 * Site JavaScript
 *
 * This file is bundled by esbuild and output to public/assets/js/main.js.
 * The base template includes it via <script src="/assets/js/main.js" defer>.
 *
 * Build:  pnpm run build
 * Watch:  pnpm run watch  (auto-rebuilds on change)
 */

// DOM ready helper
function ready(fn: () => void) {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

ready(() => {
  // Theme switcher
  const THEME_VERSION = 2;
  if (Number(localStorage.getItem("theme_v")) !== THEME_VERSION) {
    localStorage.removeItem("theme");
    localStorage.setItem("theme_v", String(THEME_VERSION));
  }
  const saved = localStorage.getItem("theme") || "neon";
  document.documentElement.setAttribute("data-theme", saved);
  updateActiveTheme(saved);

  const picker = document.querySelector<HTMLElement>(".theme-picker");
  const toggle = document.getElementById("theme-toggle");
  const dropdown = document.getElementById("theme-dropdown");
  if (!picker || !toggle || !dropdown) return;

  const isLocal = ["localhost", "127.0.0.1", ""].includes(location.hostname);
  if (!isLocal) {
    picker.style.display = "none";
    return;
  }

  toggle.addEventListener("click", () => {
    dropdown.classList.toggle("open");
  });

  dropdown.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest<HTMLButtonElement>(".theme-option");
    if (!btn) return;
    const theme = btn.dataset.theme;
    if (!theme) return;
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
    updateActiveTheme(theme);
    dropdown.classList.remove("open");
  });

  document.addEventListener("click", (e) => {
    const picker = (e.target as HTMLElement).closest(".theme-picker");
    if (!picker) dropdown.classList.remove("open");
  });

  function updateActiveTheme(theme: string) {
    document.querySelectorAll(".theme-option").forEach((el) => {
      el.classList.toggle("active", (el as HTMLElement).dataset.theme === theme);
    });
  }
});
